import React from 'react'
import styled from 'styled-components'
import * as moment from 'moment'
import * as interfaces from '../../../../../static/interfaces'
import * as constants from '../../../../../static/constants'

interface ISelectedDatesDateProps {
  date: {
    date: moment.Moment
  }
  startTime?: interfaces.IStartTime
  post?: interfaces.IPost
  fontSize?: number
}
export const ReservationSelectedDatesDate: React.VFC<ISelectedDatesDateProps> = ({
  date,
  post,
  startTime,
  fontSize = 22,
}) => {
  const durationLabel = React.useMemo(() => {
    if (!post || !startTime) {
      return null
    }
    const start = moment(`${date.date.format('MM/DD')} ${startTime.start_time}`)
    const startAt = start.format('hh:mmA')
    const endAt = start.add(post.duration, 'hours').format('hh:mmA')
    return `${startAt} - ${endAt}`
  }, [date.date, post, startTime])
  return (
    <SelectedDatesDate fontSize={fontSize}>
      <div className="DayAndDate">
        <span className="Day">{date.date.format('dddd')},</span>
        <span className="Date">{date.date.format('MMMM D')}</span>
      </div>
      {durationLabel && <span className="Duration">{durationLabel}</span>}
    </SelectedDatesDate>
  )
}

const SelectedDatesDate = styled.div`
  position: sticky;
  top: 0;
  display: flex;
  align-items: center;
  gap: 0.4rem 1.6rem;
  font-style: normal;
  font-weight: bold;
  background-color: ${constants.COLORS.white};
  font-size: ${props => props.fontSize}px;
  line-height: 2.4rem;
  padding: 1.6rem;
  margin: 0 -1.6rem;
  z-index: 1;
  @media (max-width: ${constants.BREAKPOINT_TABLET_MOBILE}px) {
    font-size: 1.8rem;
    gap: 0.8rem;
    flex-wrap: wrap;
    padding: 1.6rem 0;
    margin: 0;
  }
  .DayAndDate {
    display: flex;
    align-items: center;
    gap: 0.4rem;
  }

  .Day {
    color: ${constants.COLORS.black};
  }
  .Duration {
    color: ${constants.COLORS.primary};
  }
`
